import utils from 'components/utilsComponent';

const $stickyBlock = document.querySelector('.js-sticky');
/**
 * VK плагин
 */
utils.loadScript('//vk.com/js/api/openapi.js?120').then(() => {
    const $widget = document.getElementById('vk_widget');
    if (!$widget) {
        return;
    }

    const vk_group_id = $widget.getAttribute('data-vk-group-id');
    if (!vk_group_id) {
        return;
    }

    /**
     * Подключаем VK плагин
     */
    function VK_Widget_Init() {
        const widgetWidth = document.getElementById('vk_widget').clientWidth;

        document.getElementById('vk_widget').innerHTML = '<div id="vk_groups"></div>';

        VK.Widgets.Group('vk_groups', {
            mode: 3,
            color2: '37474F',
            width: widgetWidth,
            no_cover: 1,
        }, vk_group_id);

        /**
         * Липкий блок при скролле
         */
        if ($stickyBlock && !$stickyBlock.classList.contains('init')) {
            $stickyBlock.classList.add('init');
            utils.stickInParent($stickyBlock, 75);
        }
    };

    VK_Widget_Init();

    utils.addTrigger('resize', VK_Widget_Init);
});